// Quotation Vuex

import state from './quotationStates.js'
import * as getters from './quotationGetters.js'
import * as mutations from './quotationMutations.js'
import * as actions from './quotationActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
